export default __webpack_public_path__ + "static/media/jardinsPrivesFacebook-1200x630.2cec3da9.jpg";